// import $ from 'jquery';
import debug from 'debug';
import plugin from '../lib';
import Collapsible from './collapsible-v1.1.0.js';
import { onAvailable } from "@core/plugins/lib/selectors";

const log = debug('collapsible');
const ELEMENT_SELECTOR = '[data-collapsible]';
const PLUGIN_NAME = 'Collapsible';

onAvailable.ready(ELEMENT_SELECTOR, (element) => {
	log('onAvailable', ELEMENT_SELECTOR);
	plugin(PLUGIN_NAME, Collapsible);
	$(element)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__collapsible/plugin--bundled.js